/**
 * Registro de iconos de dominio.
 *
 * Los tokens declaran el icono por NOMBRE (`'TriangleAlert'`) para que web y
 * móvil compartan la decisión. Aquí se resuelve ese nombre al componente de
 * lucide. Se importan uno a uno —y no con `import * as Icons`— para que el
 * empaquetador pueda descartar los cientos de iconos que no usamos.
 */

import {
  Archive,
  Ban,
  Bot,
  CalendarClock,
  ChartNoAxesCombined,
  ChevronsDown,
  ChevronsUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleX,
  Clock,
  Cog,
  Crown,
  Equal,
  Eye,
  FilePen,
  Gem,
  Globe,
  Headset,
  Inbox,
  LoaderCircle,
  Mail,
  Medal,
  MessageCircle,
  MessageSquareWarning,
  OctagonAlert,
  PauseCircle,
  Phone,
  Send,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  ShieldUser,
  ShieldX,
  Store,
  ThumbsUp,
  TriangleAlert,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

const REGISTRY: Record<string, LucideIcon> = {
  Archive,
  Ban,
  Bot,
  CalendarClock,
  ChartNoAxesCombined,
  ChevronsDown,
  ChevronsUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleX,
  Clock,
  Cog,
  Crown,
  Equal,
  Eye,
  FilePen,
  Gem,
  Globe,
  Headset,
  Inbox,
  LoaderCircle,
  Mail,
  Medal,
  MessageCircle,
  MessageSquareWarning,
  OctagonAlert,
  PauseCircle,
  Phone,
  Send,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  ShieldUser,
  ShieldX,
  Store,
  ThumbsUp,
  TriangleAlert,
  Wrench,
};

/** Devuelve el componente del icono, o un círculo neutro si el nombre no existe. */
export function domainIcon(name: string): LucideIcon {
  return REGISTRY[name] ?? Circle;
}

export type { LucideIcon };
